var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex center-xs" }, [
    _c("div", { staticClass: "input-container" }, [
      _c("div", { staticClass: "row vertical-center" }, [
        _c("div", { staticClass: "col xs-1" }, [
          _c("input", {
            attrs: { type: "checkbox", GDPRChecked: _vm.GDPRChecked },
            on: {
              change: function ($event) {
                return _vm.$emit("change", $event.target.checked)
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col xs-11" }, [
          _c("p", { staticClass: "small-text text-left space-top-0" }, [
            _vm._v("\n          " + _vm._s(_vm.agreement) + "\n        "),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("p", {
        staticClass: "small-text text-left",
        domProps: { innerHTML: _vm._s(_vm.notice) },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }